import { useState } from 'react';
import { Mail, ArrowLeft, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';
import toast from 'react-hot-toast';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Veuillez saisir votre adresse email');
      return;
    }

    try {
      setIsSubmitting(true);
      
      const response = await fetch('https://x1lc-aku3-stjs.p7.xano.io/api:moW4brDB/auth/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Une erreur est survenue');
      }

      setIsSuccess(true);
      toast.success('Un email de réinitialisation vous a été envoyé');
    } catch (error) {
      toast.error('Impossible d\'envoyer l\'email de réinitialisation');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link
          to="/login"
          className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-8 mx-4 sm:mx-0"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Retour à la connexion
        </Link>

        <div className="bg-white py-8 px-4 shadow-xl sm:rounded-lg sm:px-10 border border-gray-100">
          {!isSuccess ? (
            <>
              <div className="sm:mx-auto sm:w-full sm:max-w-md mb-8">
                <h2 className="text-center text-3xl font-bold text-gray-900">
                  Mot de passe oublié ?
                </h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                  Saisissez votre email pour réinitialiser votre mot de passe
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Adresse email
                  </label>
                  <div className="mt-1 relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Mail className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={cn(
                        "block w-full pl-10 pr-3 py-2",
                        "border border-gray-300 rounded-lg",
                        "focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500",
                        "text-sm placeholder:text-gray-400"
                      )}
                      placeholder="vous@exemple.fr"
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={cn(
                    "w-full flex justify-center items-center",
                    "px-4 py-2 border border-transparent",
                    "text-sm font-medium rounded-lg",
                    "text-white bg-teal-600",
                    "hover:bg-teal-700",
                    "focus:outline-none focus:ring-2",
                    "focus:ring-offset-2 focus:ring-teal-500",
                    "disabled:opacity-50 disabled:cursor-not-allowed"
                  )}
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="animate-spin h-5 w-5 mr-2" />
                      Envoi en cours...
                    </>
                  ) : (
                    'Réinitialiser le mot de passe'
                  )}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center">
              <Mail className="mx-auto h-12 w-12 text-teal-500" />
              <h3 className="mt-4 text-lg font-medium text-gray-900">
                Vérifiez votre boîte mail
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                Si un compte existe avec cette adresse email, vous recevrez un lien
                de réinitialisation dans quelques minutes.
              </p>
              <div className="mt-6">
                <Link
                  to="/login"
                  className="text-sm font-medium text-teal-600 hover:text-teal-500"
                >
                  Retour à la connexion
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}